import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
// DS2.5
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import { IconSize } from '../../Icons/IconWrap';
import s from './IconButton.scss';
const IconButton = (_param)=>{
    var { size , className , icon: IconComponent , variant ='main'  } = _param, props = _object_without_properties(_param, [
        "size",
        "className",
        "icon",
        "variant"
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _extends({
        className: classnames(className, s['root'], s[`size-${size}`], variant && s[`variant-${variant}`], props.disabled && s['disabled'])
    }, props), /*#__PURE__*/ React.createElement(IconComponent, {
        className: s['icon'],
        size: size === 'small' ? IconSize.SMALLER : IconSize.MEDIUM,
        disableDefaultColors: true
    }));
};
IconButton.displayName = 'IconButton';
export default IconButton;
